import { useRef } from 'react';
import './TimeInterval.css';

const TimeInterval = ({ clickHandler }) => {
    const timeIntervalButtons = useRef(null);

    const changeTimeInterval = ( position ) => {
        if (position === 'days'){
            timeIntervalButtons.current.classList.add('time-interval__highlight--right');
        } else {
            timeIntervalButtons.current.classList.remove('time-interval__highlight--right');
        }
        clickHandler(position);
    }

    return (
        <div className="time-interval">
            <div ref={timeIntervalButtons} className="time-interval__highlight"></div>
            <button className="time-interval__button" onClick={() => changeTimeInterval('hours')}>Horas</button>
            <button className="time-interval__button" onClick={() => changeTimeInterval('days')}>Días</button>
        </div>
    )
}

export default TimeInterval;
